import { render } from "./MUpdateTodoModal.vue?vue&type=template&id=0340c3d0&scoped=true"
import script from "./MUpdateTodoModal.vue?vue&type=script&lang=ts"
export * from "./MUpdateTodoModal.vue?vue&type=script&lang=ts"

import "./MUpdateTodoModal.vue?vue&type=style&index=0&id=0340c3d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0340c3d0"

export default script